const mapStateToProps = (state) =>{
    const {
        service:{
            Api:{
                getDirectoryList,
            }={}
        }={},
        api:{
            directoryList,
        }={},
        user:{
            rights,
        }={},
    } = state;
    return {
        getDirectoryList,
        directoryList,
        rights,
    }
}

export default mapStateToProps;